import useLocaleHelper from "@/hooks/useLanguageHelper";

import TermsEnglish from "./markdown/TermsEnglish.mdx";
import TermsNorsk from "./markdown/TermsNorsk.mdx";

const markdownChoices = {
  no: TermsNorsk,
  en: TermsEnglish,
};

const TermsCopy = () => {
  const { currentLanguage } = useLocaleHelper();
  const Markdown = markdownChoices[currentLanguage];
  return <Markdown />;
};

export default TermsCopy;
